import { render, staticRenderFns } from "./StopIcon.vue?vue&type=template&id=3ced6822&scoped=true&"
import script from "./StopIcon.vue?vue&type=script&lang=js&"
export * from "./StopIcon.vue?vue&type=script&lang=js&"
import style0 from "./StopIcon.vue?vue&type=style&index=0&id=3ced6822&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ced6822",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
